import Vue from 'vue';
import Router from 'vue-router';
import worker from './modules/worker'
import user from './modules/user'
import form from './modules/form'
import supply from './modules/supply'
import bind from './modules/bind'

const Frame = () => import('@/views/index')
const Login = () => import('@/views/login/login')
const Register = () => import('@/views/login/Register')
const MobileTh = () => import('@/views/login/MobileTh ')
const CheckLogin = () => import('@/views/login/checkLogin')
const SignUp = () => import('@/views/login/signUp')

Vue.use(Router);

export const routerMap = [{
  path: '/',
  name: 'index',
  component: Frame,
  children: [
    worker, user, form, supply
  ],
  redirect: '/index'
}, bind]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: '登录',
        auth: false,
        getType: true,
        keepLogin: true
      },
    }, {
      path: '/Register',
      name: 'Register',
      component: Register,
      meta: {
        title: '账号注册',
        auth: false,
        getType: true,
        keepLogin: true
      },
    }, {
      path: '/MobileTh',
      name: 'MobileTh',
      component: MobileTh,
      meta: {
        title: '绑定手机号',
        auth: false
      }
    }, {
      path: '/check',
      name: 'check',
      component: CheckLogin,
      meta: {
        title: '验证登录',
        auth: false
      }
    }, {
      path: '/signUp',
      name: 'signUp',
      component: SignUp,
      meta: {
        title: '验证登录',
        auth: false
      }
    }
  ].concat(routerMap)
});

export default router
